module.exports = __webpack_public_path__ + "img/platform_big_001.323d0c50.png";